import BugReportIcon from '@mui/icons-material/BugReport';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import StarIcon from '@mui/icons-material/Star';

// Darstellungs-Metadaten (Icon/Farbe/Label) für Feedback-Typen und -Status.

export const getTypeIcon = (typ) => {
    switch (typ) {
        case 'fehler':
            return <BugReportIcon />;
        case 'verbesserung':
            return <TrendingUpIcon />;
        case 'wunsch':
            return <StarIcon />;
        default:
            return null;
    }
};

export const getTypeColor = (typ) => {
    switch (typ) {
        case 'fehler':
            return 'error';
        case 'verbesserung':
            return 'warning';
        case 'wunsch':
            return 'info';
        default:
            return 'default';
    }
};

export const getTypeLabel = (typ) => {
    switch (typ) {
        case 'fehler':
            return 'Fehler';
        case 'verbesserung':
            return 'Verbesserung';
        case 'wunsch':
            return 'Wunsch';
        default:
            return typ;
    }
};

export const getStatusColor = (status) => {
    switch (status) {
        case 'neu':
            return 'error';
        case 'in_bearbeitung':
            return 'warning';
        case 'erledigt':
            return 'success';
        default:
            return 'default';
    }
};

export const getStatusLabel = (status) => {
    switch (status) {
        case 'neu':
            return 'Neu';
        case 'in_bearbeitung':
            return 'In Bearbeitung';
        case 'erledigt':
            return 'Erledigt';
        default:
            return status;
    }
};
